export default __webpack_public_path__ + "46a63a974888b518b8d93a2dc0fd02f0.png";